"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_intl_1 = require("react-intl");
const transactionSigningSelector_1 = require("../selectors/transactionSigningSelector");
const transactionSigningAction_1 = require("../actions/transactionSigningAction");
const CommonErrorStyle_1 = __importDefault(require("./styles/CommonErrorStyle"));
const material_1 = require("@mui/material");
const GeneralError = () => {
    const classes3 = (0, CommonErrorStyle_1.default)();
    const intl = (0, react_intl_1.useIntl)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { showGeneralError } = (0, react_redux_1.useSelector)(transactionSigningSelector_1.transactionSigningSelector);
    const handleToggleCloseGeneralError = (cancel) => {
        console.log('handleToggleCloseGeneralError');
        dispatch((0, transactionSigningAction_1.toggleCloseGeneralError)(cancel));
    };
    return (react_1.default.createElement(material_1.Dialog, { open: showGeneralError, classes: { paper: classes3.dialog }, TransitionComponent: material_1.Slide, onClose: () => console.log('dismiss') },
        react_1.default.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap'
            } },
            react_1.default.createElement(material_1.Typography, { className: classes3.Error2FATitle, variant: "h3" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "general-error" })),
            react_1.default.createElement(material_1.Link, { className: classes3.IconClose, onClick: () => handleToggleCloseGeneralError(true) })),
        react_1.default.createElement(material_1.DialogContent, { className: classes3.DialogContent },
            react_1.default.createElement(material_1.ListItem, { className: classes3.ListItem },
                react_1.default.createElement(material_1.ListItemIcon, { className: classes3.WrapIcon }),
                react_1.default.createElement(material_1.ListItemText, null,
                    react_1.default.createElement(material_1.Typography, { className: classes3.typography },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "general-error-message" })))),
            react_1.default.createElement("div", { className: classes3.ConfirmButton },
                react_1.default.createElement(material_1.Button, { className: classes3.OK, name: "submit", disableTouchRipple: true, disableFocusRipple: true, onClick: () => handleToggleCloseGeneralError(true) }, intl.formatMessage({ id: 'login-2fa-otp-invalid-otp-btn-ok' }))))));
};
exports.default = GeneralError;
